export const SIGNATURE_PLAN_ID = "signature";

export const SIGNATURE_PLAN_TITLE = "Triva Signature (with Deepika)";

export const SIGNATURE_PLAN_SUBTITLE =
  "Triva App + High Touch Real-Time Support + Expert Guidance by Deepika Chalasani";

export const SIGNATURE_PLAN_DESCRIPTION =
  "A premium transformation program designed for those who prefer personalized guidance combined with technology";

export const SIGNATURE_PLAN_ADDITIONAL_INFO = "Know more about Deepika Chalasani";

export const SIGNATURE_PLAN_KNOW_MORE_URL = "https://fit4lifeindia.com/why-choose-us/";

export const SIGNATURE_PLAN_PERFECT_FOR: string[] = [
  "Complete lifestyle transformation",
  "Busy professionals",
  "Managing multiple health concerns",
  "Long-term sustainable results",
  "Close monitoring & ongoing motivation",
];

export const SIGNATURE_PLAN_WHAT_YOU_GET: string[] = [
  "Full access to all Triva App features",
  "Personalized, evolving meal plans provided as needed",
  "Guidelines provided based on your requirements",
  "Action-oriented follow-ups & adjustments as needed",
  "Mind & body coaching: stress eating, consistency, mindful habits",
  "Smart hacks for cravings, portion control & timing",
  "Supplement recommendation to ensure effectiveness and ideal potency for optimal results",
  "Integrated wellness support for health conditions & lifestyle disorders",
  "Habit-building strategies for sustainable, long-lasting health",
  "Root cause analysis and blood report insights, with proactive, real-time support during",
  "Indian working hours (9 AM – 7 PM)",
  "Personalized recipe support tailored to your lifestyle",
];
